import { render, staticRenderFns } from "./ViTeacherAcademicManagementTimeTable.vue?vue&type=template&id=ae90a860&scoped=true"
import script from "./ViTeacherAcademicManagementTimeTable.vue?vue&type=script&lang=js"
export * from "./ViTeacherAcademicManagementTimeTable.vue?vue&type=script&lang=js"
import style0 from "./ViTeacherAcademicManagementTimeTable.vue?vue&type=style&index=0&id=ae90a860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae90a860",
  null
  
)

export default component.exports